import {ANALYTICS} from 'constants/actions';

import {takeEvery} from 'redux-saga/effects';

import {onProductClick} from './productClick';

/**
 * Category EEC analytics root saga
 */
export default function* productClick() {
    yield takeEvery(ANALYTICS.EEC_PRODUCT_CLICK, onProductClick);
}
